import { operationInProgress } from '../action/profile.action'
import ActionType from '../action.types'
import serviceInterface from '../../services/service.interface'
import { message } from 'antd'

/*
Actions to be dispatched for signin
- feedback forms
    Get feedback forms 
- feedback error
*/
export function serviceError(bool, message) {
  return {
    type: ActionType.FEEDBACK_ERROR,
    hasError: bool,
    message,
  }
}

export function patientForms(forms) {
  return {
    type: ActionType.FEEDBACK_EDIT,
    forms,
  }
}

export function feedbackForms(forms) {
  return {
    type: ActionType.FEEDBACK_FORMS,
    forms,
  }
}

export function graphData({ oks, pain, rom }) {
  return {
    type: ActionType.FEEDBACK_GRAPH,
    oks,
    pain,
    rom,
  }
}

export function addForm(form) {
  return {
    type: ActionType.ADD_FEEDBACK_FORM,
    form,
  }
}

export function getFeedbackForms(customerid) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .FeedbackService()
        .getFeedbackForms(customerid)
      dispatch(operationInProgress(false))
      if (data.error) dispatch(serviceError(true, data.message))
      else dispatch(feedbackForms(data.forms))
    } catch (err) {
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getPatientFeedSchedule(patientid) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .FeedbackService()
        .getPatientFeedSchedule(patientid)
      dispatch(operationInProgress(false))
      if (data.error) dispatch(serviceError(true, data.message))
      else {
        dispatch(patientForms(data.forms))
        console.log(data.forms)
        if (!data.forms[0]) return false
        return true
      }
    } catch (err) {
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function editFeedSchedule(input) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .FeedbackService()
        .editFeedSchedule(input)
      dispatch(operationInProgress(false))
      if (data.error) dispatch(serviceError(true, data.message))
      else {
        message.success(data.message)
        return true
      }
    } catch (err) {
      dispatch(operationInProgress(false))
      message.error('failed to update')
    }
  }
}

export function getDeafultFeedSchedule(input) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .FeedbackService()
        .getDeafultFeedSchedule(input)
      dispatch(operationInProgress(false))
      if (data.error) dispatch(serviceError(true, data.message))
      else dispatch(patientForms(data.forms))
    } catch (err) {
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getFormGraphData(customerid, date) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .FeedbackService()
        .getFormGraphData(customerid, date)
      dispatch(operationInProgress(false))
      if (data.error) dispatch(serviceError(true, data.message))
      else dispatch(graphData(data))
    } catch (err) {
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getSurveyDetail(patientid) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .FeedbackService()
        .getSurveyDetail(patientid)
      dispatch(operationInProgress(false))
      if (data.error) return false
      else return data
    } catch (err) {
      console.log(err)
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getRangeExercises({ patientid, startdate, enddate }) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface
        .ExerciseService()
        .getRangeExercises(patientid, startdate, enddate)
      dispatch(operationInProgress(false))
      if (data.error) return false
      else return data.data
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
    }
  }
}
